import { Pipe, PipeTransform } from '@angular/core';

import { clienteGrupoEconomicoSituacoes } from '../cliente-grupo-economico-situacao';

@Pipe({
    name: 'clienteGrupoEconomicoSituacao'
})
export class ClienteGrupoEconomicoSituacaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = clienteGrupoEconomicoSituacoes.findIndex(situacao => situacao.id === value);
        if (index > -1) {
            return clienteGrupoEconomicoSituacoes[index].nome;
        }
        return '';
    }
}
